import React, { useEffect, useState } from 'react'
import './emoji-view-modal.styles.scss'
import Modal from '../modal/modal.component'
import pro from '@/assets/pro.png'
import heart from '@/assets/heart.png'
import laugh from '@/assets/laugh.png'
import angry from '@/assets/angry.png'
import { properCase } from '@/utils/properCase'

const EmojiViewModal = ({
  show,
  cancel,
  leaders,
  message
}) => {

  const [ reactions, setReactions ] = useState([]);
  const reactionTypes = ['likes', 'loves', 'laughs', 'angries'];

  useEffect(() => { 
    if (!message) return;
    const reacts = [];
    
    for (let type of reactionTypes) {
      if (message[type]) {
        Object.keys(message[type]).forEach(appId => {
          const reaction = message[type][appId];
          reacts.push({
            ...reaction,
            ...{
              type: type,
              appId: appId,
              'date': new Date(reaction.ts)
            }
          });
        });
      }
    }
    setReactions(reacts);
  }, [message])

  return (
    <div className='emoji-view-modal'>
      <Modal
        show={show}
        cancel={cancel}
        title="Reactions"
      >
        <div className='reaction-block'>
        {
          reactions.length > 0
          ?
          reactionTypes.map((type, index) => {
            if (reactions.filter(r => r.type === type).length === 0) return null;
            return (
            <div key={index} className='reaction-list'>
              <div className='head-row'>
                <img 
                  src={
                    type === 'likes' ? pro :
                    type === 'loves' ? heart :
                    type === 'laughs' ? laugh :
                    type === 'angries' ? angry :
                    null
                  }
                  alt={properCase(type)}
                  className='reaction-emoji' />
                <span className='reaction-type'>{type === 'angries' ? 'Dislikes' : properCase(type)}</span>
              </div>
              {
                reactions.filter(r => r.type === type)
                .map((reaction, idx) => {
                  return <div key={idx} className='reaction-user'>
                    <span className='reaction-user-name'>{leaders[reaction.appId].fName} {leaders[reaction.appId].lName}</span>
                  </div>
                })
              }
              <div className="g-space-1"></div>
            </div>
            )
          })
          :
          <p>No reactions yet.</p>
        }
        </div>
      </Modal>
    </div>
  )
}

export default EmojiViewModal